import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { saveAs } from "file-saver";
import { LocalStorageService } from "ngx-webstorage";
import { isNull } from "util";
import { environment } from "../environments/environment";
import { map } from "rxjs/operators";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class MyserviceService {
    private partnerInfoSubject = new BehaviorSubject<any>(null); // or [] if it's a list
    partnerInfo$ = this.partnerInfoSubject.asObservable();
  
    private errorHandlingInfoSubject = new BehaviorSubject<any>(null); // or [] if it's a list
    errorHandlingInfo$ = this.errorHandlingInfoSubject.asObservable();
  

    constructor(
        public localstorage: LocalStorageService,
        private http: HttpClient
    ) { }
    sendPartnerInfo(data: any) {
        this.partnerInfoSubject.next(data);
      }
    
      getPartnerInfo() {
        return this.partnerInfo$;
      }

      sendErrorHandlingInfo(data: any) {
        this.errorHandlingInfoSubject.next(data);
      }
    
      getErrorHandlingInfo() {
        return this.errorHandlingInfo$;
      }
    getDocumentTypes(token, flowFlag, database) {
        let transactions = [];
        transactions.push({
            label: "Select",
            value: "-1",
        });
        let headers = new HttpHeaders();
        headers = headers.append("Authorization", token);
        this.http
            .get(
                environment.apiUrl +
                "/utilities/documentTypes/" +
                flowFlag +
                "/" +
                database,
                { headers: headers }
            )
            .subscribe(
                (data: any) => {
                    for (var i = 0; i < data.length; i++) {
                        transactions.push({
                            label: data[i],
                            value: data[i],
                        });
                    }
                },
                (err) => {
                    //console.log(err, err.statusText, "error");
                }
            );
        return transactions;
    }
    getWarehouseDocTypes(token, database) {
        let transactions = [];
        transactions.push({
            label: "Select",
            value: "-1",
        });
        let headers = new HttpHeaders();
        headers = headers.append("Authorization", token);
        this.http
            .get(
                environment.apiUrl +
                "/warehouseOrder/documentType/" + database,
                { headers: headers }
            )
            .subscribe(
                (data: any) => {
                    for (var i = 0; i < data.length; i++) {
                        transactions.push({
                            label: data[i],
                            value: data[i],
                        });
                    }
                },
                (err) => {
                    //console.log(err, err.statusText, "error");
                }
            );
        return transactions;
    }

    getPartners(token, flowFlag, database) {
        let senders = [];
        senders.push({
            label: "Select Sender",
            value: "-1",
        });
        let headers = new HttpHeaders();
        headers = headers.append("Authorization", token);
        return this.http
            .get(
                environment.apiUrl +
                "/utilities/tradingPartners/" +
                flowFlag +
                "/" +
                database,
                { headers: headers }
            )
    }

    getTradingPartner(token, flowFlag, database){
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",    
            this.localstorage.retrieve("token")
        );
        return this.http.get(environment.apiUrl + "/partner/tradingPartners", { headers: headers })
     }

    getSenderId(token, flowFlag, database) {
        let senders = [];
        senders.push({
            label: "Select Sender",
            value: "-1",
        });
        let headers = new HttpHeaders();
        headers = headers.append("Authorization", token);
        this.http
            .get(
                environment.apiUrl +
                "/utilities/senders/" +
                flowFlag +
                "/" +
                database,
                { headers: headers }
            )
            .subscribe(
                (data: any) => {
                    for (var i = 0; i < data.length; i++) {
                        senders.push({
                            label: data[i].name,
                            value: data[i].id,
                        });
                    }
                },
                (err) => {
                    //console.log(err, err.statusText, "error");
                }
            );
        return senders;
    }

    getReceiverId(token, flowFlag, database) {
        let receivers = [];
        receivers.push({
            label: "Select Receiver",
            value: "-1",
        });
        let headers = new HttpHeaders();
        headers = headers.append("Authorization", token);
        this.http
            .get(
                environment.apiUrl +
                "/utilities/receivers/" +
                flowFlag +
                "/" +
                database,
                { headers: headers }
            )
            .subscribe(
                (data: any) => {
                    for (var i = 0; i < data.length; i++) {
                        receivers.push({
                            label: data[i].name,
                            value: data[i].id,
                        });
                    }
                },
                (err) => {
                    //console.log(err, err.statusText, "error");
                }
            );
        return receivers;
    }

    getMscvpRoles(token) {
        let mscvpRoles = [];
        mscvpRoles.push({
            label: "Select Role",
            value: "-1",
        });
        let ROLES: any = [];
        let headers = new HttpHeaders();
        headers = headers.append("Authorization", token);
        this.http
            .get(environment.apiUrl + "/utilities/mscvpRoles/", {
                headers: headers,
            })
            .subscribe(
                (data: any) => {
                    for (var i = 0; i < data.length; i++) {
                        mscvpRoles.push({
                            label: data[i].name,
                            value: data[i].id,
                        });
                    }
                },
                (err) => {
                    //console.log(err, err.statusText, "error");
                }
            );
        return mscvpRoles;
    }

    getprimaryFlows(token) {
        let primaryFlows = [];
        let headers = new HttpHeaders();
        headers = headers.append("Authorization", token);
        this.http
            .get(environment.apiUrl + "/utilities/primaryFlows/", {
                headers: headers,
            })
            .subscribe(
                (data: any) => {
                    for (var i = 0; i < data.length; i++) {
                        if (data[i].name === 'Manufacturing') {
                            primaryFlows.push({
                                label: "Cold Storage",
                                value: data[i].id,
                            });
                        }
                        else {
                            primaryFlows.push({
                                label: data[i].name,
                                value: data[i].id,
                            });
                        }
                    }
                },
                (err) => {
                    //console.log(err, err.statusText, "error");
                }
            );
        return primaryFlows;
    }

    getcorrelation(token, transaction) {
        let correlations = [];
        correlations.push({
            label: "Select",
            value: "-1",
        });
        let headers = new HttpHeaders();
        headers = headers.append("Authorization", token);
        this.http
            .get(
                environment.apiUrl + "/utilities/correlations/" + transaction,
                { headers: headers }
            )
            .subscribe(
                (data: any) => {
                    for (var i = 0; i < data.length; i++) {
                        correlations.push({
                            label: data[i],
                            value: data[i],
                        });
                    }
                },
                (err) => {
                    //console.log(err, err.statusText, "error");
                }
            );
        return correlations;
    }

    getStatus() {
        let status = [];
        status.push({ label: "Select", value: "-1" });
        status.push({ label: "SUCCESS", value: "SUCCESS" });
        status.push({ label: "DROPPED", value: "DROPPED" });
        status.push({ label: "ERROR", value: "ERROR" });
        return status;
    }

    getAckStatus() {
        let ackStatus = [];
        ackStatus.push({ label: "Select", value: "-1" });
        ackStatus.push({ label: "OVERDUE", value: "OVERDUE" });
        ackStatus.push({ label: "SUCCESS", value: "SUCCESS" });
        ackStatus.push({ label: "ACCEPTED", value: "ACCEPTED" });
        ackStatus.push({ label: "REJECTED", value: "REJECTED" });

        return ackStatus;
    }

    activeUsers(token) {
        let headers = new HttpHeaders();
        headers = headers.append("Authorization", token);
        return this.http.get(environment.apiUrl + "/user/activeUsers/", {
            headers: headers,
        });
    }
    translationFileDownloadDoc(filePath, fileId) {
        let splitElement = filePath.split("/");
        let filename = splitElement[splitElement.length - 1];

        let headers = new HttpHeaders();
        headers = headers.append(
            "Authorization",
            this.localstorage.retrieve("token")
        );
        this.http
            .get(environment.apiUrl + "/utilities/download?file=" + filePath + `&fileId=`+`${fileId}`, {
                headers: headers,
                responseType: "text",
            })
            .subscribe((response: any) => {
                let blob = new Blob([response], { type: "text/csv" });
                saveAs(blob, filename);
            });
    }

    translationFilePreview(filePath) {
        let splitElement = filePath.split("/");
        let filename = splitElement[splitElement.length - 1];

        let headers = new HttpHeaders();
        headers = headers.append(
            "Authorization",
            this.localstorage.retrieve("token")
        );
        return this.http.get(environment.apiUrl + "/utilities/download?file=" + filePath, {
            headers: headers,
            responseType: "text",
        }).pipe(
            map((response: any) => {
                return response;
            })
        );
    }

    updateReProcessColumn(params) {

        let headers = new HttpHeaders();
        headers = headers.append(
            "Authorization",
            this.localstorage.retrieve("token")
        );
        return this.http.put(environment.apiUrl + `/documentRepository/updateReprocessStatus?id=${params.id}&reprocessStatus=${params.reprocessStatus}`, {}, {
            headers: headers,
        }).pipe(
            map((response: any) => {
                return response;
            })
        );
    }

    download_Webforms_Excel(body, reportType) {
        let headers = new HttpHeaders();
        headers = headers.append(
            "Authorization",
            this.localstorage.retrieve("token")
        );
        return this.http.post(environment.apiUrl + '/downloadExcel?reportType=' + reportType, body, {headers,  responseType: 'blob'});
    }
    getListOfNotifications() {
        return this.http.get(environment.apiEndpoint + '/bannerNotifications');
    }
    getPartnersLookup() {
        let headers = new HttpHeaders();
        headers = headers.append(
            "Authorization",
            this.localstorage.retrieve("token")
        );
        return this.http.get(environment.apiUrl + '/tradingPartner/lookUp', {headers});
    }
    translationFileDownload(filePath) {
        let splitElement = filePath.split("/");
        let filename = splitElement[splitElement.length - 1];

        let headers = new HttpHeaders();
        headers = headers.append(
            "Authorization",
            this.localstorage.retrieve("token")
        );
        this.http
            .get(environment.apiUrl + "/utilities/download?file=" + filePath, {
                headers: headers,
                responseType: "text",
            })
            .subscribe((response: any) => {
                let blob = new Blob([response], { type: "text/csv" });
                saveAs(blob, filename);
            });
    }
    //For downloading multiple files as compressed zip
    multiFileDownload(csvString) {
        let headers = new HttpHeaders();
        headers = headers.append(
            "Authorization",
            this.localstorage.retrieve("token")
        );
        return this.http
            .get(environment.apiUrl + "/utilities/downloadMultipleFiles?file=" + csvString, {
                headers: headers,
                responseType: "arraybuffer",
            })
    }
    sfgFileDownload(filePath) {
        let extention = filePath.split(".")[filePath.split(".").length - 1];
        let resType;
        (extention == 'pdf' || extention == "xlsx" || extention == "csv") ? resType = "blob" : resType = "text"
        let headers = new HttpHeaders();
        headers = headers.append(
            "Authorization",
            this.localstorage.retrieve("token")
        );
        return this.http
            .get(environment.apiUrl + "/sfg/download?file=" + filePath, {
                headers: headers,
                responseType: resType,
            })
    }
    getParentWarehouses(token, flowFlag, database) {
        let parentWarehouses = [];
        let headers = new HttpHeaders();
        headers = headers.append("Authorization", token);
        this.http
            .get(
                environment.apiUrl +
                "/utilities/parentWarehouses/" +
                flowFlag +
                "/" +
                database,
                { headers: headers }
            )
            .subscribe(
                (data: any) => {
                    parentWarehouses.push({ label: "Select", value: "" })
                    for (var i = 0; i < data.length; i++) {                      
                        parentWarehouses.push({
                            label: data[i],
                            value: data[i],
                        });
                    }
                },
                (err) => {
                    //console.log(err, err.statusText, "error");
                }
            );
        return parentWarehouses;
    }

    getWarehouses(token, database, parentWarehouse) {
        let warehouses = [];
        let headers = new HttpHeaders();
        headers = headers.append("Authorization", token);
        this.http.post(`${environment.apiUrl}/utilities/listOfWarehouses`,
            { database: database, parentWarehouse: parentWarehouse }, { headers: headers })
            .subscribe(
                (data: any) => {
                    for (var i = 0; i < data.length; i++) {
                        warehouses.push({
                            label: data[i],
                            value: data[i],
                        });
                    }
                },
                (err) => {
                    //console.log(err, err.statusText, "error");
                }
            );
        return warehouses;
    }
    getProducer(token, database) {
        let producer = [];
        let headers = new HttpHeaders();
        headers = headers.append("Authorization", token);
        this.http
            .get(
                environment.apiUrl + "/sfg/producer?liveOrArchive=" +
                database,
                { headers: headers }
            )
            .subscribe(
                (data: any) => {
                    for (var i = 0; i < data.length; i++) {
                        producer.push({
                            label: data[i],
                            value: data[i],
                        });
                    }
                },
                (err) => {
                    //console.log(err, err.statusText, "error");
                }
            );
        return producer;
    }
    getConsumer(token, database) {
        let consumer = [];
        let headers = new HttpHeaders();
        headers = headers.append("Authorization", token);
        this.http
            .get(
                environment.apiUrl +
                "/sfg/consumer?liveOrArchive=" +
                database,
                { headers: headers }
            )
            .subscribe(
                (data: any) => {
                    for (var i = 0; i < data.length; i++) {
                        consumer.push({
                            label: data[i],
                            value: data[i],
                        });
                    }
                },
                (err) => {
                    //console.log(err, err.statusText, "error");
                }
            );
        return consumer;
    }
    getDocStats(){
        let ackStatusData = [];
        let headers = new HttpHeaders();
        headers = headers.append("Authorization", this.localstorage.retrieve("token"));
        this.http.get(environment.apiUrl + "/utilities/stats", { headers: headers })
            .subscribe(
                (data: any) => {
                    ackStatusData.push({ label: "Select", value: "-1" })
                    for (var i = 0; i < data.length; i++) {
                        ackStatusData.push({ label: data[i], value: data[i] });
                    }
                },
                (err) => {
                    //console.log(err, err.statusText, "error");
                }
            );
        return ackStatusData;
    }
    getAckAndApiStatus() {
        let ackStatusData = [];
        let headers = new HttpHeaders();
        headers = headers.append("Authorization", this.localstorage.retrieve("token"));
        this.http.get(environment.apiUrl + "/utilities/ackstatus", { headers: headers })
            .subscribe(
                (data: any) => {
                    ackStatusData.push({ label: "Select", value: "-1" })
                    for (var i = 0; i < data.length; i++) {
                        ackStatusData.push({ label: data[i], value: data[i] });
                    }
                },
                (err) => {
                    //console.log(err, err.statusText, "error");
                }
            );
        return ackStatusData;
    }

    getStatusDocRepo() {
        let statusArray = []
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",    
            this.localstorage.retrieve("token")
        );
        this.http.get(environment.apiUrl + "/utilities/status", { headers: headers })
        .subscribe((data: any) => {
            //     const result = (response).map(item => ({ label: item, value: item }));
            //     this.statusArray = [{ label: "Select", value: "" }, ...result];
            //     //console.log(response, "===response====");
            // })
               statusArray.push({ label: "Select", value: "-1" });
               for (var i = 0; i < data.length; i++) {                  
                    statusArray.push({ label: data[i], value: data[i] });
                }
            },
            (err) => {
                //console.log(err, err.statusText, "error");
            }
        );
    return statusArray;
    }


    //To extract details from JWT
    getUserData() {
        let data = this.localstorage.retrieve("token")
        let defaultData = {
            fileVisibility: 'false',
            isAllPartnersVisible: 'false',
            isAllSfgPartnersVisible: 'false'
        }
        //Setting default values if there is no JWT
        if (isNull(data) == true || data == "" || data.split('.').length == 0) {
            return defaultData;
        } else {
            return { ...defaultData, ...JSON.parse(atob(data.split('.')[1])) }
        }
    }
    //To get the current time based on user timezone
    getDateByTZ() {
        let zone = this.getUserData().timeZone;
        if (!zone) {
            //console.warn("Time zone is null or undefined, returning local time.");
            return new Date(); 
        }
        var timeParts = zone.split(":");
        let utcOffset = (+timeParts[0] * (60000 * 60)) + (+timeParts[1] * 60000);
        var currDate = new Date();
        let timeZoneBasedDate = new Date(currDate.toUTCString()).getTime() + utcOffset;
        return new Date(timeZoneBasedDate);
    }
    //To get list of timezones
    getTimeZones(token) {
        let headers = new HttpHeaders();
        headers = headers.append("Authorization", token);
        return this.http.get(environment.apiUrl + "/timeZones/list", { headers: headers })
    }

    getErrorHandlingReports(params) {
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",    
            this.localstorage.retrieve("token")
        );
        // http://172.17.15.249:8151/ediscv/tradingPartner/getUSbankdetails?fromDate=06/18/2025
        return this.http.get(environment.apiUrl + `/tradingPartner/getUSbankdetails?fromDate=${params.fromDate}&toDate=${params.toDate}`, { headers: headers })
    }

    getSAPIdsLookup() {
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",    
            this.localstorage.retrieve("token")
        );
        // http://172.17.15.249:8151/ediscv/tradingPartner/getUSbankdetails?fromDate=06/18/2025
        return this.http.get(environment.apiUrl + `/documentRepository/sap-ids`, { headers: headers })
    }
    //to genreate report for B2Bi partners and SFG partners
    downloadPartnerReport(path, payload, fileName, headers) {
        this.http.post(environment.apiUrl + path, payload,
            {
                responseType: "blob",
                headers: headers,
            }).subscribe(
                (response: any) => {
                    var blob = new Blob([response], {
                        type: "application/vnd.ms-excel",
                    });
                    saveAs(blob, fileName);
                },
                (error) => {
                    //console.log("Error occured" + error);
                }
            );
    }
    /*  If the user selects all the options of multiselect, instead of sending all the selected options, we are passing ["All"]
        to improve the performance */
    multiSelectValue(options, selectedOptions) {
        return options.length == selectedOptions.length ? ["All"] : selectedOptions;
    }
    /*     TO get the background color for the status based on status and reprocess status*/
    // getColorBadge(status, reProcessStatus) {
    //     if (reProcessStatus.toUpperCase(reProcessStatus) === 'RESUBMITTED') {
    //         return 'reprocessBadge';
    //     }
    //     return status.toUpperCase() == 'SUCCESS' ? 'successBadge' : status.toUpperCase() == 'ERROR' ? 'errorBadge' : status.toUpperCase() == 'DROPPED' ? 'droppedBadge' : ''
    // }
    getColorBadge(status, reProcessStatus) {
    if (reProcessStatus && reProcessStatus.toUpperCase() === 'RESUBMITTED') {
        return 'reprocessBadge';
    }
    if (status) {
        return status.toUpperCase() === 'SUCCESS' ? 'successBadge' :
               status.toUpperCase() === 'ERROR' ? 'errorBadge' :
               status.toUpperCase() === 'ALERT' ? 'alertBadge' :
               status.toUpperCase() === 'DROPPED' ? 'droppedBadge' : '';
    }
    return ''; 
}
    getStatusBadges() {
        return ([
            { class: 'successBadge', label: 'SUCCESS' },
            { class: 'alertBadge', label: 'ALERT' },
            { class: 'errorBadge', label: 'ERROR' },
            { class: 'droppedBadge', label: 'DROP' },
            { class: 'reprocessBadge', label: 'RESUBMITTED' }
        ])
    }

    postReportDownload(reqBody:any,headers:any) {
        return this.http
            .post(
                environment.apiUrl + "/documentRepository/generateReport",
                reqBody,
                {
                    responseType: "blob",
                    headers: headers,
                }
            )
    }
    getReports(userId:any,headers:any){
        return this.http.get(environment.apiUrl + "/documentRepository/reports/" + userId, { headers: headers })
    }
}
